export type PaginationInfo = ResponsePaginationInfo | RequestPaginationInfo;

export interface ResponsePaginationInfo {
    readonly page: number;
    readonly totalNumberOfResults: number;
    readonly resultsPerPage: number;
}

export interface RequestPaginationInfo {
    readonly page: number;
    readonly resultsPerPage: number;
}

export const defaultPaginationInfo: ResponsePaginationInfo = {
    resultsPerPage: 10,
    page: 0,
    totalNumberOfResults: 0
};

export const singleResultPaginationInfo: ResponsePaginationInfo = {
    resultsPerPage: 1,
    page: 0,
    totalNumberOfResults: 0
};

export const mapPaginationInfo: RequestPaginationInfo = {
    resultsPerPage: 1000,
    page: 0
};
